<template>
    <div>
        <div v-if="loading">{{ __('Loading rules..') }}</div>
        <div v-if="!loading && rules != null && rules.length == 0">
            {{ __('No rules have been created yet') }}
        </div>
        <table
            class="table table-responsive"
            v-if="rules != null && !loading && rules.length > 0"
        >
            <tr>
                <th>{{ __('Label') }}</th>
                <th>{{ __('Ratings') }}</th>
                <th>{{ __('Sources') }}</th>
                <th>{{ __('Review Status') }}</th>
                <th>{{ __('Sentiment Groups') }}</th>
                <th>{{ __('Emails') }}</th>
                <th></th>
            </tr>
            <tr v-for="rule in rules" :key="rule.id">
                <td>{{ rule.label }}</td>
                <td>
                    {{
                        rule.min_rating !== null
                            ? rule.min_rating + "-" + rule.max_rating
                            : "Any"
                    }}
                </td>
                <td>
                    {{
                        rule.sources
                            ? rule.sources
                                  .map(source => labelizeGeneral(source))
                                  .join(", ")
                            : "Any"
                    }}
                </td>
                <td>
                    {{
                        rule.response_status != null
                            ? rule.response_status
                                  .map(response_status => labelizeGeneral(response_status))
                                  .join(", ")
                            : "Any"
                    }}
                </td>
                <td>
                    {{
                        rule.sentiment_group
                            ? rule.sentiment_group
                            : "Any"
                    }}
                </td>
                <td>
                    <ul>
                        <li v-for="email in rule.emails">
                            {{ email }}
                        </li>
                    </ul>
                </td>
                <td>
                    <button class="btn btn-default btn-rounded" @click="editAlert(rule)"><i class="fa fa-edit"></i></button>
                    <button class="btn btn-default btn-rounded" @click="deleteAlert(rule)"><i class="fa fa-times"></i></button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        groupId: Number
    },
    data() {
        return {
            rules: null,
            loading: false
        };
    },
    mounted() {
        this.loadRules();
    },
    methods: {
        loadRules() {
            this.loading = true;
            axios
                .get(`/api/reviews/group-alerts/${this.groupId}`)
                .then(response => {
                    this.rules = response.data;
                    this.loading = false;
                });
        },
        deleteAlert(rule) {
            axios
                .delete(`/api/reviews/group-alerts/${this.groupId}/${rule.id}`)
                .then(response => {
                    this.loadRules();
                });
        },
        editAlert(rule) {
            this.$parent.$emit('edit-alert', rule);
        }
    }
};
</script>
